import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bang-orange",
  "use": "icon-bang-orange-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bang-orange\"><path d=\"M0 512a512 512 0 101024 0A512 512 0 100 512z\" fill=\"#FF751A\" /><path d=\"M537.6 646.4L556.8 256H454.4l19.2 390.4zm-32 160c19.2 0 32-6.4 44.8-19.2 12.8-12.8 19.2-25.6 19.2-44.8s-6.4-25.6-19.2-38.4c-12.8-12.8-25.6-19.2-44.8-19.2s-32 6.4-38.4 19.2c-12.8 12.8-19.2 25.6-19.2 44.8s6.4 32 19.2 38.4c6.4 12.8 25.6 19.2 38.4 19.2z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol